<h2 mat-dialog-title>{{ 'Change Profile Photo' | translate }}</h2>

<mat-dialog-content>
    <div class="row">
        <div class="col-md-12 text-center mb-3">
            <img [src]="previewImage" alt="preview"
                 class="rounded-circle"
                 style="width:120px;height:120px;object-fit:cover;border:1px solid #eee;">
        </div>
        <div class="col-md-12 text-center">
            <input type="file" #fileInput accept=".jpg,.jpeg" style="display:none;"
                   (change)="onFileSelected($event.target.files); fileInput.value='';">
            <button mat-raised-button type="button" class="btn btn-primary"
                    (click)="fileInput.click()">
                {{ 'Choose Image' | translate }}
            </button>
            <p class="text-muted mt-2 mb-0" style="font-size:12px;">
                {{ 'Allowed: JPG / JPEG, max 500 KB' | translate }}
            </p>
            <p *ngIf="selectedFileName" class="mt-1 mb-0" style="font-size:12px;">
                {{ selectedFileName }}
            </p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" class="btn btn-secondary mr-2" (click)="Cancel()">
        {{ 'Cancel' | translate }}
    </button>
    <button mat-raised-button type="button" class="btn btn-success" (click)="Upload()">
        {{ 'Upload' | translate }}
    </button>
</mat-dialog-actions>
